<div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form">
    <div class="row">
      <div
        *ngFor="let question of questions"
        class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4"
      >
        <app-question [question]="question" [form]="form"></app-question>
      </div>
      <div style="width: 25vw">
        <label translate>Upload Component image</label>
        <input
          type="text"
          [value]="fileName"
          readonly
          (click)="fileInput.click()"
          class="custom-file-input"
          placeholder="Attach File"
        />
        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          accept="image/*,application/pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,video/mp4"
          class="custom-file-input"
          style="display: none"
        />
      </div>
    </div>
    <div>
      <div *ngIf="form.invalid && form.touched" class="error-message">
        <p translate>Please fill in all required fields</p>
      </div>
      <button
        mat-raised-button
        color="primary"
        class="buttons"
        type="submit"
        id="real-file"
        [disabled]="!form.valid"
      >
        @if(flag == false) {
        <span translate>Add Component</span>
        } @if(flag == true) {
        <span translate>update Component</span>
        }
      </button>
    </div>
  </form>
</div>
